
































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import ZenButton from '@reciprocity/button';
import { deleteRequest } from '../../../utils/client/client';

export default Vue.extend({
  name: 'WatchUnsubscribePage',
  components: { ZenButton },
  data() {
    return {
      successful: false,
    };
  },
  computed: {
    ...mapGetters(['routes', 'csrfToken']),
  },
  created() {
    this.setPageTitle({ title: 'Stop watching object', visible: false });
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
      showAlert: 'alerts/show',
    }),
    async unsubscribe() {
      const url = this.routes.stopWatchingObject;
      const params = this.$route.params;
      try {
        await deleteRequest({
          url: url.replace('__OBJ_TYPE__', params.obj_type).replace('__ID__', params.id),
          headers: { 'X-CSRF-Token': this.csrfToken },
        });
        this.successful = true;
      } catch (error) {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      }
    },
  },
});
